import { TCalendarsUser } from '@/types/TCalendar';
import apiClient from '@/utils/apiClient';

const agentPrefix = '/agent/:agentId';
const CALENDAR_API_PATH = `/api/calendars${agentPrefix}`;
const CALENDAR_CONFIGURE_API_PATH = `/api/calendars/${agentPrefix}/google-calendar`;

export const updateCalendar = async (payload: any): Promise<unknown> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'PUT',
		endPoint: CALENDAR_API_PATH.replace(':agentId', agentId),
		body,
	});

	return response;
};

export const getCalendars = async (agentId: string): Promise<{ data: TCalendarsUser }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: CALENDAR_API_PATH.replace(':agentId', agentId),
	});

	return response;
};

export const deleteCalendar = async (agentId: string): Promise<{ success: boolean }> => {
	const response = await apiClient.request({
		method: 'DELETE',
		endPoint: CALENDAR_API_PATH.replace(':agentId', agentId),
	});

	return response;
};

export const configureCalendar = async (payload: {
	encAcc: string;
	encRefr: string;
	agentId: string;
}): Promise<unknown> => {
	const { agentId, ...body } = payload;
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CALENDAR_CONFIGURE_API_PATH.replace(':agentId', agentId),
		body,
	});

	return response;
};
